import api from "../index";

export const GetGenerateCommissionApi = (params) => api.get(`Admin/IBCommission-GenerateWithdraw?${params}`);
export const GetGenerateCommissionCalculationApi = (IbUserId, params) => api.get(`IBMaster/GetIb-CommisionDetails/${IbUserId}?${params}`);
export const GetWithdrawCommissionApi = (params) => api.get(`Admin/IBCommission-GenerateWithdraw?${params}`);
export const CommissionRollBackApi = (data) => api.patch(`IBRollBack/IB_Commission_RollBack-From-History`, data);
export const GetGenerateCommissionCalculationrollbackApi = (IbUserId, params) => api.get(`IBMaster/GetIb-CommisionCalculation/${IbUserId}?${params}`);
export const DepositReminderLogApi = (params) => api.get(`Admin/Get-All-Deposit-Reminder-Log?${params}`);
export const AuditLogByUserIdApi = (UserId, params) => api.get(`Admin/AuditLog-ByUserId/${UserId}?${params}`);
